<template>
  <DataGridColumn :header-class-name="'grid-id-column' + (selectionMode ? ' selection-mode' : '')"
                  :class-name="'grid-id-column' + (selectionMode ? ' selection-mode' : '')"
                  :resizable="false"
                  width="50"
                  align="center"
                  fixed="left">
    <template slot="header" slot-scope="params">
      <div class="column-header-cont" v-if="!params.isHidden">
        <div class="column-wrap">
          <el-checkbox v-if="selectionMode"
                       :disabled="params.$table.isAllCheckboxDisabled"
                       :indeterminate="params.$table.isIndeterminate"
                       :value="params.$table.isAllCheckboxDisabled ? false : params.$table.isAllSelected"
                       @change="checked => params.$table.triggerCheckAllEvent({}, checked)"></el-checkbox>
          <span class="column-label">#</span>
        </div></div>
    </template>
    <template slot-scope="params">
      <div class="column-cont" v-if="!params.isHidden" :class="{'selection-column': params.$table.selection.length > 0}">
        <el-tooltip popper-class="grid-id-column-row-popper"
                    placement="right"
                    :open-delay="500">
          <template #content>
            <div class="custom">第<span class="digit">{{rowOffset + params.rowIndex + 1}}</span>行</div>
          </template>
          <div class="column-wrap"
               title="">
            <el-checkbox v-if="selectionMode"
                         :disabled="params.$table.checkboxOpts.checkMethod && !params.$table.checkboxOpts.checkMethod(params)"
                         :value="params.$table.selection.includes(params.row)"
                         @change="checked => params.$table.triggerCheckRowEvent({}, params, checked)"></el-checkbox>
            <span class="column-no">{{params.rowIndex + 1}}</span>
          </div>
        </el-tooltip>
      </div>
    </template>
  </DataGridColumn>
</template>

<script>
import DataGridColumn from '../DataGridColumn'
export default {
  name: 'DataGridIdColumn',
  components: {DataGridColumn},
  props: {
    selectionMode: {
      type: Boolean,
      default: false
    },
    pageIndex: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    rowOffset () {
      return Math.max(this.pageIndex - 1, 0) * this.pageSize
    }
  }
}
</script>

<style lang="scss">
  .grid-id-column {
    border-right: 1px solid #e8eaec;
    &.selection-mode {
      .column-header-cont,
      .column-cont {
        text-align: center;
      }
      .column-header-cont {
        .column-wrap {
          .el-checkbox {
            display: inline-block;
          }
          .column-label {
            display: none;
          }
        }
      }
      .column-cont {
        &.selection-column {
          .column-wrap {
            .el-checkbox {
              display: inline-block;
            }
            .column-no {
              display: none;
            }
          }
        }
      }
      &:hover {
        .column-cont {
          .el-checkbox {
            display: inline-block;
          }
          .column-no {
            display: none;
          }
        }
      }
    }
    .column-header-cont,
    .column-cont {
      .column-wrap {
        padding-left: 3px;
        padding-right: 3px;
        .el-checkbox {
          display: none;
          .el-checkbox__input {
            & > .el-checkbox__inner {
              vertical-align: 1px;
            }
          }
        }
      }
    }
    .vxe-cell--title {
      display: block!important;
      overflow: visible!important;
    }
  }
  .vxe-table {
    &.border--full {
      .grid-id-column {
        border-right: none;
      }
    }
  }
  .grid-id-column-row-popper {
    border-radius: 0!important;
    background-color: #909399!important;
    padding: 2px 8px!important;
    &[x-placement^=right] {
      .popper__arrow {
        top: 50%!important;
        left: -4px!important;
        border-width: 4px 4px 4px 0!important;
        border-right-color: #909399!important;
        margin-top: -4px;
        &:after {
          bottom: -4px!important;
          border-width: 3px 3px 3px 0!important;
          border-right-color: #909399!important;
        }
      }
    }
    .custom {
      font-size: 12px;
      transform: scale(.96);
      & > .digit {
        margin-left: 2px;
        margin-right: 2px;
      }
    }
  }
</style>
